/**
 * presets.ts — queue #675 §UAT-2026-07-13-R675 §R675-2 안 A.
 *
 * ②단계(공통 능력 선택) 상단 "추천 프리셋" 카드의 정의 + 순수 판정 함수(React·부수효과 0).
 * 쿡북 6레시피는 `common-showcase` 의 `RECIPES`(단일 SSOT)에서 파생할 뿐 코드를 재선언하지
 * 않는다 — `web-api-minimal` 만 스캐폴드 전용 하드코딩 1건(§R675-2 결정 A).
 *
 * ★프리셋 클릭 = 교체(replace) 시맨틱 — union 이 아니다(§R675-0②). 이후 사용자가 체크박스로
 * 자유 추가/해제할 수 있어야 하고, 활성 하이라이트 판정(isPresetActive)이 결정적이어야 하므로
 * 교체를 택했다(§R675-2 Out-of-Scope②).
 * ★전이 코드(take-this.json deps.codes)는 프리셋 정의에 포함하지 않는다 — 기존
 * `ScaffoldModuleStep` 의 transitiveCodes 재계산 로직이 그대로 담당한다(§R639 전이 SSOT 원칙).
 */
import { RECIPES, type Recipe } from '../../common-showcase';

export interface ScaffoldPreset {
  id: string; // 'web-api-minimal' | recipe.id
  nameKey: string; // i18n 키
  summaryKey: string; // i18n 키
  codes: string[]; // 직접 선택될 코드(정렬)
}

/** ★ 스캐폴드 전용 하드코딩 1건 — 최소 웹 API 시작 조합 */
export const WEB_API_MINIMAL_CODES = ['C001', 'C002', 'C003', 'C039', 'C042'];

export const SCAFFOLD_PRESETS: ScaffoldPreset[] = [
  {
    id: 'web-api-minimal',
    nameKey: 'projectScaffold.preset.web-api-minimal.name',
    summaryKey: 'projectScaffold.preset.web-api-minimal.summary',
    codes: [...WEB_API_MINIMAL_CODES].sort(),
  },
  // 쿡북 6레시피 — 동일 SSOT(RECIPES) 파생 · 코드 재선언 0
  ...RECIPES.map((r: Recipe) => ({
    id: r.id,
    nameKey: r.nameKey, // 기존 showcase.recipe.<id>.name 재사용
    summaryKey: r.summaryKey, // 기존 showcase.recipe.<id>.summary 재사용
    codes: r.modules.map((m) => m.code).sort(),
  })),
];

/** 프리셋 클릭 = 해당 코드 집합을 그대로 적용(교체) — 이후 자유 추가/해제 */
export function applyPreset(preset: ScaffoldPreset): Set<string> {
  return new Set(preset.codes);
}

/** 현재 선택이 프리셋과 정확히 일치하는가(활성 하이라이트 판정) — 순수 집합 동등 */
export function isPresetActive(preset: ScaffoldPreset, selected: Set<string>): boolean {
  return selected.size === preset.codes.length && preset.codes.every((c) => selected.has(c));
}
